import { render, staticRenderFns } from "./HouseComponent.vue?vue&type=template&id=d1f61d2c&"
import script from "./HouseComponent.vue?vue&type=script&lang=js&"
export * from "./HouseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports